const styles = {
    paper: {
        border: '1px solid #d3d4d5',
    },
};

export default styles;